export default "__VITE_ASSET__e6254aaa__"